import { z } from "zod";
import { ColorTokenData } from "./color";
import { OpacityTokenData } from "./opacity";
import { tokenAliasOrValue } from "./base";

export const ShadowType = z.enum(["Drop", "Inner"]);

export const ShadowLayerValue = z.object({
  color: ColorTokenData,
  x: z.number(),
  y: z.number(),
  radius: z.number(),
  spread: z.number(),
  opacity: OpacityTokenData.optional(),
  type: ShadowType,
});

const ShadowTokenDataBase = tokenAliasOrValue(ShadowLayerValue);
export const ShadowValue = z.array(ShadowTokenDataBase);
export const ShadowTokenData = tokenAliasOrValue(z.array(ShadowTokenDataBase));

export type ShadowType = z.infer<typeof ShadowType>;
export type ShadowLayerValue = z.infer<typeof ShadowLayerValue>;
export type ShadowValue = z.infer<typeof ShadowValue>;
export type ShadowTokenData = z.infer<typeof ShadowTokenData>;
